/*jshint esversion: 6 */
import PropTypes from 'prop-types';
import React from 'react';

import dashboard from '../../assets/icons/dashboard.svg';
import dataScience from '../../assets/icons/data-science.svg';
import feature from '../../assets/icons/feature.svg';
import genAI from '../../assets/icons/genAI.svg';
import searchTerm from '../../assets/icons/search-term.svg';
import table from '../../assets/icons/table.svg';

const iconMap = {
    'Dashboard': dashboard,
    'Table': table,
    'Data Science Product': dataScience,
    'Search Term': searchTerm,
    'Feature': feature,
    'Data Set': table,
    'Data Entity': table,
    'Schema': table,
    'Gen AI Use Case' : genAI
}

export default function ProductIcon({ id, productType }) {
    return <img data-testid={id} src={iconMap[productType]} alt={productType + " Icon"} className='typeIcon' />;
}

ProductIcon.propTypes = {
    id: PropTypes.string,
    productType: PropTypes.string
}